import {useEncodeURI} from '@/helpers'
/**
 * for auth
 */

export const AUTH_API_CONFIG = {
  WHO_AM_I: 'admin/who_am_i',
  LOGIN: 'login/admin',
  CHANGE_PASSWORD: 'admin/password',
  VERIFY_2FA: 'admin/2fa/verify',
  ENABLE_2FA: 'admin/2fa/enable',
  DISABLE_2FA: 'admin/2fa/disable'
}



/**
 * for campaigns
 */

export const CAMPAIGN_API_CONFIG = {
  GET_ALL: 'admin/campaign',
  GET_BY_ID: (id:number) => `admin/campaign/${id}`
}

/**
 * for surveys
 */

export const SURVEY_API_CONFIG = {
  CREATE: 'admin/survey',
  GET_BY_ID: (id: number) => `admin/survey/${id}`,
  UPDATE: (id: number) => `admin/survey/${id}`,
  GET_LIST: 'admin/surveys',
  GET_ANALYTICS: (id: number) => `admin/survey/${id}/analytics`,
  GET_RESPONDENTS: 'admin/survey/respondents',
  GET_CUSTOMER_ANSWERS: (customerId: number) => `admin/customer/${customerId}/answers`,
}

/**
 * for products
 */

export const PRODUCT_API_CONFIG = {
  CREATE: 'admin/product',
  GET_BY_ID: (id: number) => `admin/product/${id}`,
  UPDATE: (id: number) => `admin/product/${id}`,
}

/**
 * for grades (uwin)
 */

export const GRADE_API_CONFIG = {
  CREATE: 'admin/grade',
  GET_BY_ID: (id: number) => `admin/grade/${id}`,
  UPDATE: (id: number) => `admin/grade/${id}`,
}

/**
 * for missions (uwin)
 */

export const MISSION_API_CONFIG = {
  CREATE: 'admin/mission',
  GET_BY_ID: (id: number) => `admin/mission/${id}`,
  UPDATE: (id: number) => `admin/mission/${id}`,
}

/**
 * for invoices (uwin)
 */

export const INVOICE_API_CONFIG = {
  GET_BY_ID: (id: number) => `admin/invoice/${id}`,
  ADD_ITEMS: 'admin/invoice/items',
}

/**
 * for uwin images — uploaded via API, served as static files from the file server (no auth header)
 */

export const IMAGE_API_CONFIG = {
  UPLOAD: 'admin/images',
  FILE_URL: {
    survey: (filename: string) => `${CONFIG['API_SERVER']}file/surveys/${encodeURIComponent(filename)}`,
    question: (filename: string) => `${CONFIG['API_SERVER']}file/questions/${encodeURIComponent(filename)}`,
    option: (filename: string) => `${CONFIG['API_SERVER']}file/options/${encodeURIComponent(filename)}`,
    invoice: (filename: string) => `${CONFIG['API_SERVER']}file/invoices/${encodeURIComponent(filename)}`,
    mission: (filename: string) => `${CONFIG['API_SERVER']}file/missions/${encodeURIComponent(filename)}`,
    banner: (filename: string) => `${CONFIG['API_SERVER']}file/banners/${encodeURIComponent(filename)}`
  },
}

/**
 * for card summary
 */

export const CARD_SUMMARY_API_CONFIG = {
  GET_STATS: 'admin/report/data/stats'
}


/**
 * for file manager
 */

export const FILE_MANAGER_API_CONFIG = {
  GET_LIST_ROOT: '/admin/filemanager/ls',
  GET_LIST_FOLDER_AND_FILES:(name:string) => `/admin/filemanager/ls/${useEncodeURI(name)}`,
  CREATE_FOLDER:(path:string) => `/admin/filemanager/newfolder/${path}`,
  RENAME_FILE_OR_FOLDER: (path:string) => `/admin/filemanager/rename/${path}`,
  DELETE_FILE_OR_FOLDER:(currentPath:string, name:string) => `/admin/filemanager/${currentPath}?name=${name}`,
  UPLOAD_FILE:(currentPath:string) => `/admin/filemanager/upload/${currentPath}`,
  MOVE_FILE: '/admin/filemanager/mv',
}


/**
 * for form
 */

export const FORM_API_CONFIG = {
  GET_FORM: (url: string, name: string) => `${url}${name}?rand=${String(Math.random())}`,
}

/**
 * for report
 */

export const REPORT_API_CONFIG = {
  GET_INFO: (reportName: string) => `/admin/report/info/${reportName}?rand=${String(Math.random())}`,
  GET_DATA: (reportName: string) => `/admin/report/data/${reportName}`,
  DOWNLOAD_REPORT: (reportName: string, format: string) => `/admin/report/download/${reportName}/${format}`,
}

/**
 * for menu
 */

export const EXPORT_API_CONFIG = {
  GET_MENU: '/admin/menu'
}

/**
 * for generate voucher
 */

export const GENERATE_VOUCHER_API_CONFIG = {
  GENERATE: 'admin/generate'
}

export const IMPORT_VOUCHER_API_CONFIG = {
  ADMIN_IMPORT_MOBILE: '/admin/import_mobile'
}


/**
 * for ratio coins
 */

export const RATIO_COINS_API_CONFIG = {
  GET_RATIO_COINS: '/admin/exchange_ratio?label=charge',
  PUT_RATIO_COINS: '/admin/exchange_ratio/charge'
}


/**
 * for boomerang invoices
 */

export const BOOMERANG_INVOICES_API_CONFIG = {
  GET_INVOICE_DETAIL: (id:number) => `/admin/cashback/invoice-detail?id_eq=${id}`,
  POST_SAVE_INVOICE: (id:number) => `/admin/update_invoice_acks/${id}`,
  POST_SAVE_FORM: `/admin/update_invoice`,
  GET_RECALC_CASHBACK: (id:number) => `/admin/cashback/recalc/${id}`
}


export const BOOMERANG_USER_DETAIL_API_CONFIG = {
  GET_USER_DETAIL: (id:number) => `/admin/data/user/info?user_id_eq=${id}`,
  POST_USER_FINANCE: '/admin/report/data/user-finance',
}


export const BOOMERANG_TICKET_API_CONFIG = {
  GET_STATUS_TICKET: '/admin/report/data/tickets',
  GET_REPLIES_TICKET:(id:number) => `/admin/ticket-replies?thread_id_eq=${id}`,
  CHANGE_STATUS_TICKET:  '/admin/ticket/change_status',
  SEND_REPLY_TICKET:  '/admin/ticket/admin_reply',
  UPLOAD_ATTACHMENT:  'admin/ticket/ticket_reply_attachments',
}



/**
 * for tickets (shrm)
 */

export const TICKET_API_CONFIG = {
  TICKETS: '/admin/tickets',
  TICKET: (id: number) => `/admin/ticket/${id}`,
  TICKET_CREATE: '/admin/ticket',
  TICKET_REPLY: (id: number) => `/admin/ticket/${id}/reply`,
  TICKET_ASSIGN: (id: number) => `/admin/ticket/${id}/assign`,
  TICKET_TRANSFER: (id: number) => `/admin/ticket/${id}/transfer`,
  TICKET_STATUS: (id: number) => `/admin/ticket/${id}/status`,
  TICKET_PRIORITY: (id: number) => `/admin/ticket/${id}/priority`,
  TICKET_DEPARTMENTS: '/admin/ticket/departments',
  TICKET_SOURCES: '/admin/ticket/sources',
  TICKET_SOURCE: (id: number) => `/admin/ticket/sources/${id}`,
  TICKET_STATS: '/admin/ticket/stats',
}

/**
 * Admin notifications (ClickHouse feed served by the ticket service)
 */
export const NOTIFICATION_API_CONFIG = {
  NOTIFICATIONS: '/admin/notifications',
  NOTIFICATIONS_READ: '/admin/notifications/read',
}


export const BNPL_API_CONFIG = {
  GENERATE_PASSKEY: '/admin/vouchers/bind',
}


/**
 * Lotteries (shrm)
 */
export const LOTTERY_API_CONFIG = {
  LOTTERIES: '/admin/lotteries',
  LOTTERY: (id: number) => `/admin/lotteries/${id}`,
  LOTTERY_ITEMS: (id: number) => `/admin/lotteries/${id}/items`,
  LOTTERY_ITEM: (id: number) => `/admin/lotteries/items/${id}`,
  LOTTERY_DRAW_PREVIEW: (id: number) => `/admin/lotteries/${id}/draw/preview`,
  LOTTERY_DRAW_ELIGIBLE: (id: number) => `/admin/lotteries/${id}/draw/eligible`,
  LOTTERY_DRAW: (id: number) => `/admin/lotteries/${id}/draw`,
  LOTTERY_WINNERS: (id: number) => `/admin/lotteries/${id}/winners`,
}


/***
 * for page builders BOOMERANG
 */

export const BOOMERANG_PAGE_BUILDER_API_CONFIG = {
  GET_LAYOUT_INDEX : 'layouts/index',
  PUT_LAYOUT_INDEX: 'admin/layouts/index'
}

/**
 * for gorji codes
 */

export const CODES_API_CONFIG = {
  IMPORT: 'admin/codes/import'
}
